import { defaultFacilityTypes } from "../amorg-common";
import { colors } from "../designSystem/colors/color";
import { iconName } from "../designSystem/icons/Icons";

export function getFacilityTypeIcon(facilityTypeId:string):iconName
{
    switch(facilityTypeId){
        case defaultFacilityTypes.onePersonOffice.id: return'facility_meetingRoom';
        case defaultFacilityTypes.multiPersonOffice.id: return 'facility_meetingRoom';
        case defaultFacilityTypes.reception.id: return 'facility_reception';
        case defaultFacilityTypes.other.id: return 'facility_other';
        case defaultFacilityTypes.hallway.id: return 'facility_hallway';
        case defaultFacilityTypes.restroom.id: return 'facility_restRoom';
        case defaultFacilityTypes.cloakroom.id: return 'facility_cloakRoom';
        case defaultFacilityTypes.gym.id: return 'facility_gym';
        case defaultFacilityTypes.bathroom.id: return 'facility_bathRoom';
        case defaultFacilityTypes.kitchen.id: return 'facility_kitchen';
        case defaultFacilityTypes.canteen.id: return 'facility_canteen';
        case defaultFacilityTypes.kitchenette.id: return 'facility_kitchenette';
        case defaultFacilityTypes.cleaningRoom.id: return  'facility_cleaningRoom';
        case defaultFacilityTypes.meetingRoom.id: return 'facility_meetingRoom';
        case defaultFacilityTypes.storageRoom.id: return 'facility_storageRoom';
        case defaultFacilityTypes.serverRoom.id: return 'facility_serverRoom';
        case defaultFacilityTypes.relaxationRoom.id: return 'facility_relaxationRoom';
        case defaultFacilityTypes.therapyRoom.id: return 'facility_physicalTherapy';
        case defaultFacilityTypes.entertainmentRoom.id: return 'facility_entertainment';
        case defaultFacilityTypes.storageFacility.id: return 'facility_storageRoom';
        case defaultFacilityTypes.stairs.id: return 'facility_stairs';
        case defaultFacilityTypes.elevator.id: return 'facility_elevator';
        case defaultFacilityTypes.production.id: return 'facility_production';
        case defaultFacilityTypes.boilerRoom.id: return 'facility_boiler_room';
        case defaultFacilityTypes.heatExchangerRoom.id: return 'facility_heat_exchanger_room';
        default: return 'facility_other';
    }
}

export function getInspectionPointStatusIconDetails(status:'passed' | 'failed' | 'pending')
: {icon:iconName, color:string}
{
    let icon:iconName = 'actions_unavailable'
    switch(status){
        case 'passed': icon = 'status_ok'; break;
        case 'failed': icon = 'status_error'; break;
        case 'pending': icon = 'status_error'; break
    }

    let color = colors.text.light;
    switch(status){
        case 'passed': color = colors.icon.success; break;
        case 'failed': color = colors.icon.error; break;
        case 'pending': color = colors.icon.pending; break;
    }

    return { icon, color };
}